import { addAccount, delAccount, getAccount, getAccountById, updateAccount } from '@/api/account'
import { message } from 'ant-design-vue'

export class AccountController {
  static async page (params: COMMON.API.QueryParams & {label: string, phone: string}) {
    const { code, data } = await getAccount(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async add (data: ACCOUNT.Detail) {
    const { code, msg } = await addAccount(data)
    code === 0 ? message.success('新增成功') : message.error(msg)
  }

  static async update (data: ACCOUNT.Detail) {
    const { code, msg } = await updateAccount(data)
    code === 0 ? message.success('编辑成功') : message.error(msg)
  }

  static async del (id: string) {
    const { code, msg } = await delAccount(id)
    code === 0 ? message.success('删除成功') : message.error(msg)
  }

  static async byId (id: string) {
    return await getAccountById(id)
  }
}
